import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faExchangeAlt } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'wilson-timeline-modal-legend',
  imports: [TranslatePipe, FontAwesomeModule],
  templateUrl: './timeline-modal-legend.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./timeline-modal-legend.component.scss'],
})
export class TimelineModalLegendComponent {
  public faExchange = faExchangeAlt;
}
